var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCalendarFillIcon = function SvgCalendarFillIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_5591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3.82175H21C21.2652 3.82175 21.5196 3.9271 21.7071 4.11464C21.8946 4.30218 22 4.55653 22 4.82175V20.8217C22 21.087 21.8946 21.3413 21.7071 21.5289C21.5196 21.7164 21.2652 21.8217 21 21.8217H3C2.73478 21.8217 2.48043 21.7164 2.29289 21.5289C2.10536 21.3413 2 21.087 2 20.8217V4.82175C2 4.55653 2.10536 4.30218 2.29289 4.11464C2.48043 3.9271 2.73478 3.82175 3 3.82175H7V1.82175H9V3.82175H15V1.82175H17V3.82175ZM20 11.8217H4V19.8217H20V11.8217ZM15 5.82175H9V7.82175H7V5.82175H4V9.82175H20V5.82175H17V7.82175H15V5.82175ZM6 13.8217H8V15.8217H6V13.8217ZM11 13.8217H13V15.8217H11V13.8217ZM16 13.8217H18V15.8217H16V13.8217Z",
    fill: "#747474"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_5591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.821747)"
  })))));
};
export default SvgCalendarFillIcon;